import classNames from 'classnames';
import React from 'react';

import './LimitedTimer.scss';
import { milisecondsToTime } from './utils/milisecondsToTime';
interface TimerProps {
  timeToExpire: number;
  className?: string;
}

export const LimitedTimer: React.FC<TimerProps> = ({
  timeToExpire,
  className,
}) => {
  const [timer, setTimer] = React.useState({
    hours: '',
    minutes: '',
    seconds: '',
    miliseconds: 0,
  });

  React.useEffect(() => {
    const milliseconds = timeToExpire;
    const parsedTime = milisecondsToTime(milliseconds);

    setTimer(parsedTime);
  }, [timeToExpire]);

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      const nextSecondInMilliseconds = timer.miliseconds - 1000;
      const parsedTime = milisecondsToTime(nextSecondInMilliseconds);

      if (nextSecondInMilliseconds < 0) {
        clearTimeout(timeOut);
      } else {
        setTimer(parsedTime);
      }
    }, 1000);

    return () => {
      clearTimeout(timeOut);
    };
  }, [timer]);

  return (
    <div className={classNames('limited-timer', className)}>
      <div className="container">
        <h3 className="title">Limited time offer</h3>
        <h5 className="subtitle">80% OFF to buy Premium</h5>
        <div className="numbers">
          <div className="number">{timer.minutes[0]}</div>
          <div className="number">{timer.minutes[1]}</div>
          <div className="number-divider">:</div>
          <div className="number">{timer.seconds[0]}</div>
          <div className="number">{timer.seconds[1]}</div>
        </div>
      </div>
      <div className="sale">
        <img src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/paywall/80.png" />
      </div>
    </div>
  );
};
